

import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from "@angular/core";
import {HrefDirective} from "./directives/href.directive";
import {Aot2JitSharingService} from "../../services/aot2jitsharing.service";
import {ShareButtonsDirective} from "./directives/share-buttons.directive";

let ArticleDirectivesModule = NgModule({
  declarations: [
    ShareButtonsDirective,
    HrefDirective
  ],
  providers: [
    Aot2JitSharingService
  ],
  exports: [
    ShareButtonsDirective,
    HrefDirective
  ],
  schemas:[CUSTOM_ELEMENTS_SCHEMA]
})(class ArticleDirectivesModuleClass {});

export { ArticleDirectivesModule }



// WEBPACK FOOTER //
// ./src/app/shared/directives/article/articledirectives.module.ts